import * as Sentry from '@sentry/react'

import { CASE_ITEM_TYPE_TRANSLATION_IDS } from 'Constants/caseItemType'

import { dashOrSpaceToUnderscore } from '../dashOrSpaceToUnderscore/dashOrSpaceToUnderscore.util'

export const getCaseItemTypeTranslationId = (caseItemType: string) => {
  const formattedCaseType = dashOrSpaceToUnderscore(caseItemType)
  const title =
    formattedCaseType in CASE_ITEM_TYPE_TRANSLATION_IDS
      ? CASE_ITEM_TYPE_TRANSLATION_IDS[
          formattedCaseType as keyof typeof CASE_ITEM_TYPE_TRANSLATION_IDS
        ]
      : undefined

  if (!title) {
    Sentry.captureException(
      new Error(
        `getCaseItemTypeTranslationId: unknown caseType returned from the API: ${formattedCaseType}`,
      ),
    )

    return 'Unknown_case_type'
  }

  return title
}
